import { useMutation } from '@tanstack/react-query';

import { stripeService } from '../services/stripe';

export const useUpdateStripeClient = () => {
  const { mutateAsync, isLoading } = useMutation({
    mutationFn: (email: string) => stripeService.updateClient({ email }),
    mutationKey: ['updateStripeClient'],
  });

  return {
    updateStripeClient: mutateAsync,
    isUpdatingStripeClient: isLoading,
  };
};
